import * as React from 'react';
import { CheckinOrderFragment, CheckoutOrderFragment } from '@websky/graphql';
import { SelectedServicesState as CheckoutSelectedServicesState } from '../Checkout/store/selectedServices/reducers';
import { SelectedServicesState as CheckinSelectedServicesState } from '../Modules/Checkin/store/selectedServices/reducers';

export const AvailableServicesCountContext = React.createContext<{
	order: CheckoutOrderFragment | CheckinOrderFragment;
	selectedServices: CheckoutSelectedServicesState | CheckinSelectedServicesState;
}>({ order: null, selectedServices: null });

const AvailableServicesCountContextProvider = AvailableServicesCountContext.Provider;
export default AvailableServicesCountContextProvider;
